<template>
  <a-modal :title="isAdd ? '新建学生' : '修改学生'" :maskClosable="false" :width="640" :visible="visible"
    :confirmLoading="confirmLoading" :cancelText="'取消'" :okText="'确定'" @ok="handleSubmit" @cancel="handleCancel">
    <a-form layout="horizontal" :form="form">
      <!-- 学生姓名 -->
      <a-form-item label="学生姓名" :labelCol="{ lg: { span: 7 } }" :wrapperCol="{ lg: { span: 13 } }">
        <a-input type="text" :maxLength="45" @blur="onblurStudentName" v-decorator="[
          'studentName',
          {
            rules: [
              { required: true, message: '请输入' },
              { min: 2, message: '至少输入2个字符' },
              { max: 45, message: '最多输入45个字符' }]
          },
        ]" />
      </a-form-item>

      <!-- 性别 -->
      <a-form-item label="性别" :labelCol="{ lg: { span: 7 } }" :wrapperCol="{ lg: { span: 13 } }">
        <a-select placeholder="请选择" v-decorator="[
          'gender',
          { rules: [{ required: true, message: '请选择' }] },
        ]">
          <a-select-option v-for="(item, index) in $store.getters.gender" :key="index" :value="item.value">{{ item.code
          }}</a-select-option>
        </a-select>
      </a-form-item>

      <!-- 出生日期 -->
      <a-form-item label="出生日期" :labelCol="{ lg: { span: 7 } }" :wrapperCol="{ lg: { span: 13 } }">
        <a-date-picker class="modal-form-item" v-decorator="['birthday']" />
      </a-form-item>

      <!-- 学号 -->
      <a-form-item label="学号" :labelCol="{ lg: { span: 7 } }" :wrapperCol="{ lg: { span: 13 } }">
        <a-input type="text" v-decorator="['studentNumber']" :maxLength="64" />
      </a-form-item>

      <!-- 学校名称 -->
      <a-form-item label="学校" :labelCol="{ lg: { span: 7 } }" :wrapperCol="{ lg: { span: 13 } }">
        <a-select showSearch placeholder="请选择" :filterOption="false" @search="searchSchool" :disabled="isSchool"
          :notFoundContent="searchSchoolLoading ? undefined : '没有查询结果'" v-decorator="[
            'schoolId',
            { rules: [{ required: true, message: '请选择' }] },
          ]">
          <a-spin v-if="searchSchoolLoading" slot="notFoundContent" size="small" />
          <a-select-option v-for="d in schoolList" :key="d.id">{{
            d.schoolName
          }}</a-select-option>
        </a-select>
      </a-form-item>

      <!-- 年级 -->
      <a-form-item label="年级" :labelCol="{ lg: { span: 7 } }" :wrapperCol="{ lg: { span: 13 } }">
        <a-select placeholder="请选择" @change="gradeChange" v-decorator="[
          'gradeId',
          { rules: [{ required: true, message: '请选择' }] },
        ]">
          <a-select-option v-for="(item, index) in schoolGradeList" :key="index" :value="item.gradeTagId">
            {{ item.gradeName }}
          </a-select-option>
        </a-select>
      </a-form-item>

      <!-- 所在学校班级 -->
      <a-form-item label="班级" :labelCol="{ lg: { span: 7 } }" :wrapperCol="{ lg: { span: 13 } }">
        <a-select showSearch placeholder="请选择" :filterOption="false" @search="searchClass"
          :disabled="!form.getFieldValue('gradeId')" :notFoundContent="searchLoading_class ? undefined : '没有查询结果'"
          v-decorator="[
            'classId',
            { rules: [{ required: true, message: '请选择' }] },
          ]">
          <a-select-option v-for="d in classList" :key="d.id" :value="d.id">{{
            d.className
          }}</a-select-option>
        </a-select>
      </a-form-item>
      <a-form-item label="证件类型" :labelCol="{ lg: { span: 7 } }" :wrapperCol="{ lg: { span: 13 } }">
        <a-radio-group name="radioGroup" :default-value="1" v-model="idCardType">
          <a-radio value="1">
            身份证
          </a-radio>
          <a-radio value="2">
            护照
          </a-radio>
        </a-radio-group>
      </a-form-item>
      <a-form-item :label="idLabel" :labelCol="{ lg: { span: 7 } }" :wrapperCol="{ lg: { span: 13 } }">
        <a-input type="text" v-decorator="[
          'idCard',
          { rules: idCardRule },
        ]" placeholder="请输入您的身份证号" :maxLength="idMaxLength" />
      </a-form-item>
    </a-form>
  </a-modal>
</template>

<script>
import student from '../../api/student'

import school from '../../api/school'

import sourceClass from '../../api/sourceClass'

import moment from 'moment'

import Vue from 'vue'
export default {
  name: 'studentFormModal',
  data() {
    return {
      visible: false,
      confirmLoading: false,
      form: this.$form.createForm(this),
      isAdd: true,
      studentId: '',
      updateData: {},
      searchSchoolLoading: false, //搜索学校loading
      searchLoading_class: false, //搜索班级loading
      schoolList: [], //学校list
      classList: [], //班级list
      isSchool: false, //是否是学校
      idCardType: '1',
      idMaxLength: 18,
      schoolGradeList: [],
      idLabel: '身份证号',
      idCardRule: [
        {
          pattern: /^[0-9]{17}[0-9Xx]$/,
          message: '请输入18位身份证号：前17位数字，最后一位数字或X'
        }
      ]
    }
  },
  watch: {
    idCardType(val) {
      if (val == 1) {
        this.idMaxLength = 18
        this.idLabel = '身份证号'
        this.idCardRule = [
          {
            pattern: /^[0-9]{17}[0-9Xx]$/,
            message: '请输入18位身份证号：前17位数字，最后一位数字或X'
          }
        ]
      } else {
        this.idMaxLength = 30
        this.idLabel = '护照号'
        this.idCardRule = [
          {
            required: false,
          }
        ]
      }
      // this.form.setFieldsValue({ idCard: '' })
    }
  },
  methods: {
    //年级改变
    gradeChange(key) {
      if (this.form.getFieldsValue().classId) this.form.setFieldsValue({ classId: null })
      sourceClass.getClass({ gradeId: key }).then((res) => {
        this.classList = res.data
      })
    },

    //搜索学校
    searchSchool(val = '') {
      this.searchSchoolLoading = true
      school.searchSchool({ schoolName: val }).then((res) => {
        this.searchSchoolLoading = false
        this.schoolList = res.data
      })
    },

    //初始化，显示
    async init(type, params) {
      console.log(type, params, '初始化内容')
      this.visible = true
      this.isAdd = type === 'add' ? true : false
      //初始化form表单数据
      if (params) {
        this.updateData = params
        let formData = {}
        formData.birthday = params.birthday ? moment(params.birthday) : ''
        if (params.gender == 0) {
          formData.gender = '未知'
        } else {
          formData.gender = params.gender.toString()
        }
        formData.gradeId = params.gradeId
        // 处理年级
        if (!this.schoolGradeList.find(item => item.gradeTagId == params.gradeId)) {
          // formData.gradeId = this.$store.getters.getGradeScope.find(item => item.id == params.gradeId).tagName
          formData.gradeId = params.gradeName
          formData.classId = params.className
          this.classList = []
        } else {
          sourceClass.getClass({ gradeId: params.gradeId }).then((res) => {
            this.classList = res.data
            formData.classId = params.classId
            this.form.setFieldsValue({ classId: params.classId })
          })
        }
        if (params.idCard) {
          formData.idCard = params.idCard
        }
        this.idCardType = params.idCardType
        formData.schoolId = params.schoolId
        formData.studentName = params.studentName
        formData.studentNumber = params.studentNumber
        //记录当前学生的ID
        this.studentId = params.id
        this.$nextTick(() => {
          this.form.setFieldsValue(formData)
        })
      } else {
        this.form.resetFields()
        this.idCardType = '1'
        //如果是学校登录着，默认学校
        if (this.isSchool) {
          setTimeout(() => {
            this.form.setFieldsValue({ schoolId: this.schoolList[0].id })
          }, 100)
        }
      }
    },

    //隐藏
    handleCancel() {
      this.visible = false
      this.form.resetFields()
      this.$emit('closeForm')
    },

    //提交表单
    handleSubmit(e) {
      e.preventDefault()
      this.form.validateFields((err, value) => {
        value.birthday = value.birthday
          ? value.birthday.format('YYYY-MM-DD')
          : ''
        value.idCardType = this.idCardType
        if (!value.idCard) value.idCard = ''
        console.log('输入的内容是：', value, typeof value.gradeId)
        if (typeof value.gradeId == 'string') {
          this.$message.error(value.gradeId + '不在当前学校的年级范围内')
          return
        }
        //校验通过
        if (!err) {
          if (this.isAdd) {
            this.addStudent(value)
          } else {
            this.updateStudent(value)
          }
        }
      })
    },

    //新增学生
    addStudent(value) {
      student.addStudent(value).then((res) => {
        this.$message.success('新增成功')
        this.handleCancel()
        this.$emit('addStudent')
      })
    },

    //修改学生
    updateStudent(value) {
      student.updateStudent(this.studentId, value).then((res) => {
        this.$message.success('修改成功')
        Object.assign(this.updateData, value)
        this.$emit('editStudent', res.data)
        this.handleCancel()
      })
    },

    //班级列表
    searchClass(val = '') {
      this.searchLoading_class = true
      sourceClass
        .getOriginalClassList({ className: val, pageSize: 999999 })
        .then((res) => {
          console.log('当前的班级列表是', res.data.list)
          this.searchLoading_class = false
          this.classList = res.data.list
        })
    },
    // 检查含有中文的姓名中有空格，则自动去空格
    onblurStudentName() {
      this.$nextTick(() => {
        let studentName = this.form.getFieldsValue().studentName
        const res = /^[0-9a-zA-Z ]+$/.test(studentName)
        if (studentName && !res) {
          const len = studentName.length
          studentName = studentName.replaceAll(' ', '')
          this.form.setFieldsValue({ studentName: studentName })
          if (len != studentName.length)
            this.$message.warning('姓名中不能包含空格，已经自动去空格')
        } else {
          this.form.setFieldsValue({
            studentName: studentName ? studentName.trim() : null,
          })
        }
      })
    },
  },
  created() {
    //加载初始化码表
    this.searchSchool()
    // this.searchClass()
    //如果登录者是学校
    this.schoolGradeList = Vue.ls.get('schoolGrade')
    this.$store.dispatch('getUserInfo').then((res) => {
      //只有课程方，学校、平台才有权限
      let roleId = res.accRole.id.toString()
      this.isSchool = roleId == '3' ? true : false
    })
  },
}
</script>
<style lang="scss" scoped>
@import 'src/config/var';

.modal-form-item {
  width: 100% !important;
}
</style>
